import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {keyBy, values} from 'lodash'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  let stateMap = keyBy(state.versetzungsplaene, 'userId')
  result.versetzungsplaene?.forEach(vp => {
    const userId = vp.userId
    let existing = stateMap[userId]
    if (existing) {
      stateMap[userId] = {
        ...existing,
        abteilungen: vp.abteilungen,
        abteilungsZeiten: vp.abteilungsZeiten,
      }
    } else {
      stateMap[userId] = vp
    }
  })
  return {
    ...state,
    versetzungsplaene: values(stateMap),
    ueberplanungen: result.ueberplanungen,
    isLoading: false,
    hasDraftEinsaetze: result.hasDraftEinsaetze,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload, state) {
  try {
    return await Api.readVersetzungsplan(state.visibleAzubis ? state.visibleAzubis.map(a => a.id).join(',') : '')
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
